// extracted by mini-css-extract-plugin
export default {"avatarDropdown":"AvatarDropdown_avatarDropdown__XGfcB","hasAvatarDropdown":"AvatarDropdown_hasAvatarDropdown__79sIk"};